export default __webpack_public_path__ + "static/media/152848.c8f40203.jpg";